import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Mail } from 'lucide-react';

const Footer = () => {
    const navigate = useNavigate();

    return (
        <footer className="bg-gray-900 text-white mt-16">
            <div className="container mx-auto px-4 lg:px-8 py-12 lg:py-16">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 lg:gap-12">
                    {/* Brand */}
                    <div>
                        <h3 className="text-2xl font-bold mb-4 tracking-tight">FASHION HUB</h3>
                        <p className="text-gray-400 text-sm leading-relaxed">
                            Minimalist design meets exceptional craftsmanship. Creating timeless pieces for the modern aesthetic.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="font-semibold mb-4 text-sm uppercase tracking-wide">Quick Links</h4>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <span onClick={() => navigate('/template7')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">
                                    Home
                                </span>
                            </li>
                            <li>
                                <span onClick={() => navigate('/template7/shop')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">
                                    Shop
                                </span>
                            </li>
                            <li>
                                <span onClick={() => navigate('/template7/about')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">
                                    About
                                </span>
                            </li>
                            <li>
                                <span onClick={() => navigate('/template7/contact')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">
                                    Contact
                                </span>
                            </li>
                            <li>
                                <span onClick={() => navigate('/template7/orders')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">
                                    Orders
                                </span>
                            </li>
                        </ul>
                    </div>

                    {/* Customer Service */}
                    <div>
                        <h4 className="font-semibold mb-4 text-sm uppercase tracking-wide">Customer Service</h4>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <span onClick={() => navigate('/template7/shipping-exchange')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">
                                    Shipping & Returns
                                </span>
                            </li>
                            <li>
                                <span onClick={() => navigate('/template7/privacy-policy')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">
                                    Privacy Policy
                                </span>
                            </li>
                            <li>
                                <span onClick={() => navigate('/template7/terms-conditions')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">
                                    Terms & Conditions
                                </span>
                            </li>
                            <li>
                                <span onClick={() => navigate('/template7/faqs')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">
                                    FAQ
                                </span>
                            </li>
                        </ul>
                    </div>

                    {/* Connect */}
                    <div>
                        <h4 className="font-semibold mb-4 text-sm uppercase tracking-wide">Connect</h4>
                        <div className="flex gap-4 mb-4">
                            <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors">
                                <Instagram size={18} />
                            </a>
                            <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors">
                                <Facebook size={18} />
                            </a>
                            <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors">
                                <Twitter size={18} />
                            </a>
                        </div>
                        <p className="text-gray-400 text-sm">hello@FASHION HUB.com</p>
                    </div>
                </div>

                <div className="border-t border-gray-800 mt-12 pt-8">
                    <p className="text-center text-gray-500 text-sm">
                        © 2024 FASHION HUB. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
